import { useQuery } from "@tanstack/react-query";
import {
  getFunderImpact,
  getFunderFinancial,
  getFunderPrograms,
  getFunderReports,
} from "../api";
import { useAuth } from "../context/authContext";

export function useFunderImpactHook({ token, userId, enabled = true }) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["funderImpact", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getFunderImpact({ token: resolvedToken });
      if (!result.ok) {
        throw new Error(result.error || "Unable to fetch impact data");
      }
      return result.impact;
    },
  });
}

export function useFunderFinancialHook({ token, userId, enabled = true }) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["funderFinancial", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getFunderFinancial({ token: resolvedToken });
      if (!result.ok) {
        throw new Error(result.error || "Unable to fetch financial data");
      }
      return result.financial;
    },
  });
}

export function useFunderProgramsHook({ token, userId, enabled = true }) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["funderPrograms", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getFunderPrograms({ token: resolvedToken });
      if (!result.ok) {
        throw new Error(result.error || "Unable to fetch programs data");
      }
      return result.programs;
    },
  });
}

export function useFunderReportsHook({ token, userId, enabled = true }) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["funderReports", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getFunderReports({ token: resolvedToken });
      if (!result.ok) {
        throw new Error(result.error || "Unable to fetch reports data");
      }
      return result.reports;
    },
  });
}
